import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import {
  CANCEL_PROPOSAL,
  CHANGE_STATUS,
  REACTIVE_PROPOSAL,
  CHECK_CPF_PROPOSAL,
  CREATE_PROPOSAL,
  DELETE_PROPOSAL,
  GET_PROPOSAL,
  GET_PROPOSAL_ASSOCIATES,
  GET_PROPOSAL_BY_ID,
  UPDATE_PROPOSAL,
} from './actionType';

import { ProposalApiResponseError, ProposalApiResponseSuccess } from './action';

import {
  cancelProposal as proposalCancel,
  checkCpfProposal,
  createProposal as proposalCreate,
  deleteProposal as proposalDelete,
  getProposal as proposalGet,
  getProposalByAssociates as getByAssociate,
  proposalChangeStatus,
  proposalReactive,
  updateProposal as proposalUpdate,
} from '../../helpers/backend_helper';
import { notifyError, notifySuccess } from '../../components/notify';

function* getProposal({ payload }) {
  try {
    const response = yield call(proposalGet, payload.cpf_cnpj);
    yield put(ProposalApiResponseSuccess(GET_PROPOSAL, response));
  } catch (error) {
    yield put(ProposalApiResponseError(GET_PROPOSAL, error));
  }
}

function* getProposalById({ payload }) {
  try {
    const response = yield call(proposalGet, payload.cpf_cnpj);
    yield put(ProposalApiResponseSuccess(GET_PROPOSAL_BY_ID, response));
  } catch (error) {
    yield put(ProposalApiResponseError(GET_PROPOSAL_BY_ID, error));
  }
}

function* getProposalByAssociates({ payload }) {
  try {
    if (payload === null) {
      return;
    }
    const response = yield call(getByAssociate, payload);
    yield put(ProposalApiResponseSuccess(GET_PROPOSAL_ASSOCIATES, response));
  } catch (error) {
    yield put(ProposalApiResponseError(GET_PROPOSAL_ASSOCIATES, error));
  }
}

function* createProposal({ payload }) {
  try {
    const response = yield call(proposalCreate, payload.data);
    yield put(ProposalApiResponseSuccess(CREATE_PROPOSAL, response));
    notifySuccess('Proposta criada com sucesso!');
    payload.history.goBack();
  } catch (error) {
    yield put(ProposalApiResponseError(CREATE_PROPOSAL, error));
    notifyError('Erro ao criar proposta!');
  }
}

function* updateProposal({ payload }) {
  try {
    const response = yield call(proposalUpdate, {
      id: payload.id,
      data: payload.data,
    });
    yield put(ProposalApiResponseSuccess(UPDATE_PROPOSAL, response));
    notifySuccess('Proposta atualizada com sucesso!');
    payload.history.goBack();
  } catch (error) {
    yield put(ProposalApiResponseError(UPDATE_PROPOSAL, error));
    notifyError('Erro ao atualizar proposta!');
  }
}

function* deleteProposal(data) {
  try {
    const response = yield call(proposalDelete, data.payload.id);
    yield put(ProposalApiResponseSuccess(DELETE_PROPOSAL, response));
    notifySuccess('Proposta deletada com sucesso!');
  } catch (error) {
    yield put(ProposalApiResponseError(DELETE_PROPOSAL, error));
    notifyError('Erro ao deletar proposta!');
  }
}

function* checkProposalCpf(data) {
  try {
    const response = yield call(checkCpfProposal, data.payload.cpf);
    yield put(ProposalApiResponseSuccess(CHECK_CPF_PROPOSAL, response));
    data.payload.history.push(`/propostas/list/${response.customer.hashid}`);
  } catch (error) {
    yield put(ProposalApiResponseError(CHECK_CPF_PROPOSAL, error));
    data.payload.history.push(
      `/associados/novo/proposal?cpf=${data.payload.cpf}`
    );
  }
}

function* cancelProposal({ payload }) {
  const { data } = payload;
  try {
    const response = yield call(proposalCancel, data);
    yield put(ProposalApiResponseSuccess(CANCEL_PROPOSAL, response));
    notifySuccess('Proposta cancelada com sucesso!');
  } catch (error) {
    yield put(ProposalApiResponseError(CANCEL_PROPOSAL, error));
    notifyError('Erro ao cancelar proposta!');
  }
}

function* changeStatus({ payload }) {
  const { status, reason, proposal_id } = payload;

  try {
    const response = yield call(proposalChangeStatus, {
      status,
      reason,
      proposal_id,
    });
    yield put(ProposalApiResponseSuccess(CHANGE_STATUS, response));
    notifySuccess('Proposta atualizada com sucesso!');
  } catch (error) {
    yield put(ProposalApiResponseError(CHANGE_STATUS, error));
    notifyError('Erro ao atualizar proposta!');
  }
}

function* reactiveProposal({ payload }) {
  const { status_id, reason, proposal_id } = payload;

  try {
    const response = yield call(proposalReactive, {
      status_id,
      reason,
      proposal_id,
    });
    yield put(ProposalApiResponseSuccess(REACTIVE_PROPOSAL, response));
  } catch (error) {
    yield put(ProposalApiResponseError(REACTIVE_PROPOSAL, error));
    notifyError('Erro ao atualizar proposta!');
  }
}

export function* watchCheckProposalCpf() {
  yield takeEvery(CHECK_CPF_PROPOSAL, checkProposalCpf);
}

export function* watchGetProposalByCpfCnpj() {
  yield takeEvery(GET_PROPOSAL_BY_ID, getProposalById);
}

export function* watchGetProposal() {
  yield takeEvery(GET_PROPOSAL, getProposal);
}

export function* watchCreateProposal() {
  yield takeEvery(CREATE_PROPOSAL, createProposal);
}

export function* watchUpdateProposal() {
  yield takeEvery(UPDATE_PROPOSAL, updateProposal);
}

export function* watchDeleteProposal() {
  yield takeEvery(DELETE_PROPOSAL, deleteProposal);
}

export function* watchGetProposalByAssociates() {
  yield takeEvery(GET_PROPOSAL_ASSOCIATES, getProposalByAssociates);
}

export function* watchCancelProposal() {
  yield takeEvery(CANCEL_PROPOSAL, cancelProposal);
}

export function* watchChangeStatus() {
  yield takeEvery(CHANGE_STATUS, changeStatus);
}

export function* watchReactiveProposal() {
  yield takeEvery(REACTIVE_PROPOSAL, reactiveProposal);
}

function* ProposalSaga() {
  yield all([fork(watchGetProposal)]);
  yield all([fork(watchCreateProposal)]);
  yield all([fork(watchUpdateProposal)]);
  yield all([fork(watchDeleteProposal)]);
  yield all([fork(watchCheckProposalCpf)]);
  yield all([fork(watchGetProposalByAssociates)]);
  yield all([fork(watchGetProposalByCpfCnpj)]);
  yield all([fork(watchCancelProposal)]);
  yield all([fork(watchChangeStatus)]);
  yield all([fork(watchReactiveProposal)]);
}

export default ProposalSaga;
